import { Loader2 } from "lucide-react";
import type { ReactNode } from "react";

import { Alert, AlertDescription } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";

// The tunnel dialogs share one way to show a refusal and a pending submit.

export function FormError({ error }: { error?: string }) {
	if (!error) return null;
	return (
		<Alert variant="destructive">
			<AlertDescription>{error}</AlertDescription>
		</Alert>
	);
}

export function SubmitButton({ pending, children }: { pending: boolean; children: ReactNode }) {
	return (
		<Button type="submit" disabled={pending}>
			{pending && <Loader2 aria-hidden className="size-4 animate-spin" />}
			{children}
		</Button>
	);
}
